<script lang="ts">
	import { imgSrc } from "$lib/serv/image-details";
	import Logo from "$lib/ui/shared/icons/Logo.svelte";

	type Social = { light?: string, dark?: string };

	export let appstores: [string?, string?][];
	export let tallogo: { light?: string, dark?: string };
	export let socials: { insta: Social, fb: Social, x: Social };

</script>

<section class="seo_footer">
	<div class="logo"><Logo /></div>
	<article class="content">
		<div class="socials">
			<article>
				{#each appstores as [img, url]}
					<a href={url} target="_blank">
						<img src={imgSrc(img)} alt="App store">
					</a>
				{/each}
			</article>
			<article>
				<a class="show-light" href="https://www.instagram.com/_mrd_za/" target="_blank">
					<img src={imgSrc(socials.insta.light)} alt="Mr D instagram">
				</a>
				<a class="show-light" href="https://web.facebook.com/MrDFood/" target="_blank">
					<img src={imgSrc(socials.fb.light)} alt="Mr D facebook">
				</a>
				<a class="show-light" href="https://x.com/MrD_SouthAfrica" target="_blank">
					<img src={imgSrc(socials.x.light)} alt="Mr D X">
				</a>

				<a class="show-dark" href="https://www.instagram.com/_mrd_za/" target="_blank">
					<img src={imgSrc(socials.insta.dark)} alt="Mr D instagram">
				</a>
				<a class="show-dark" href="https://web.facebook.com/MrDFood/" target="_blank">
					<img src={imgSrc(socials.fb.dark)} alt="Mr D facebook">
				</a>
				<a class="show-dark" href="https://x.com/MrD_SouthAfrica" target="_blank">
					<img src={imgSrc(socials.x.dark)} alt="Mr D X">
				</a>
			</article>
		</div>
		<div class="navigation_items">
			<article>
				<h6 class="label-xl">Work with us</h6>
				<div>
					<a href="/about/become-a-partner" target="_blank" class="label-l">Become a Partner</a>
					<a href="/about/become-a-driver" target="_blank" class="label-l">Become a Driver</a>
					<a href="/about/careers" target="_blank" class="label-l">Careers</a>
				</div>
			</article>
			<article>
				<h6 class="label-xl">Mr D</h6>
				<div>
					<a href="https://www.mrdfood.com/snackme" target="_blank" class="label-l">SnackMe gifting</a>
					<a href="/info/mega_ebucks_day" target="_blank" class="label-l">Mega eBucks Day</a>
					<a href="https://www.mrdfood.com/corporate-vouchers" target="_blank" class="label-l">Corporate Vouchers</a>
				</div>
			</article>
			<article>
				<h6 class="label-xl">Contact us</h6>
				<div>
					<!-- <a href="https://www.mrdfood.com/contact" target="_blank" class="label-l">Ideas & Complaints</a> -->
					<a href="/help" target="_blank" class="label-l">Help</a>
					<a href="/help/faqs" target="_blank" class="label-l">FAQs</a>
					<a href="https://takealotgroup.atlassian.net/servicedesk/customer/portal/74" target="_blank" class="label-l">Log intellectual property complaint</a>
				</div>
			</article>
		</div>
		<div class="information_section">
			<article class="terms">
				<a href="https://www.mrdfood.com/responsible-disclosure-policy" target="_blank" class="body-s">Responsible Disclosure Policy</a>
				<a href="https://www.mrdfood.com/privacy-policy" target="_blank" class="body-s">Privacy Policy</a>
				<a href="https://www.mrdfood.com/terms" target="_blank" class="body-s">Terms & Conditions</a>
				<a href="https://www.mrdfood.com/human-rights-statement" target="_blank" class="body-s">Human Rights Statement</a>
				<a href="https://www.mrdfood.com/speak-up-process" target="_blank" class="body-s">Speak Up Process</a>
				<a href="/delivery/best-restaurants" class="body-s">Best Restaurants</a>
				<a href="/delivery/restaurants-near-me" class="body-s">Restaurants Near Me</a>
				<a href="/delivery/stores/takealotnow-near-me" class="body-s">TakealotNOW</a>
			</article>
			<article class="pty">
				<p>
					<span>© Mr D (Pty) Ltd. All rights reserved. Reg 1992/04664/07. VAT number: 4330 165 400.</span>
					<span>12th floor, 10 Rua Vasco da Gama Plain, Foreshore, Cape Town</span>
				</p>
			</article>
			<div class="tal-group">
				<img class="show-light" src={imgSrc(tallogo.light)} alt="Takealot logo">
				<img class="show-dark" src={imgSrc(tallogo.dark)} alt="Takealot logo">
			</div>
		</div>
	</article>
</section>

<style lang="scss">
	@use 'color';
	@use 'screen';

	.seo_footer {
		position: relative;
		margin-top: 6rem;
		width: 100%;
		background: color.$object-elevation-3dp;
		padding: 2rem;
		display: flex;
		flex-direction: column;
		border-radius: 3.6rem;
		box-shadow: -1px -1px 2px -1px color.$on-background-low-importance;
		@media(min-width: 870px) {
			flex-direction: row;
			margin-top: 8rem;
		}
		@media(screen.$md) { padding: 4rem 3rem; }
		@media(screen.$mdl) {
			margin-top: 10rem;
		}
		.logo {
			@media(min-width: 870px) {
				position: absolute;
				min-width: 50px;
			}
			@media(screen.$md) { position: relative; }
		}
		.content {
			position: relative;
			display: flex;
			flex-direction: column;
			// @media(min-width: 870px) { padding-left: 2rem; }
			@media(screen.$md) { padding-left: 4rem; }
			@media(screen.$mdl) { padding-left: 6rem; }
			@media(screen.$lg) { padding-left: 7rem; }
			.socials {
				display: flex;
				margin: 3.5rem 0 3rem 0;
				@media(screen.$sm) {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}
				@media(min-width: 870px) { margin: 7rem 0 3rem 0; }
				@media(screen.$md) { margin: 0.5rem 0 4rem 0; }
				article {
					&:nth-of-type(1) {
						display: flex;
						flex-direction: column;
						@media(min-width: 540px) {
							width: 100%;
							flex-direction: row;
							gap: 1rem;
						}
						@media(screen.$sm) { width: unset; }
					}
					&:nth-of-type(2) {
						position: absolute;
						bottom: calc(100% + 0.55rem);
						right: 0;
						@media(screen.$sm) {
							display: flex;
							position: relative;
							bottom: unset;
							right: unset;
						}
						a {
							margin-right: 1rem;
							&:last-child { margin-right: 0; }
							@media(min-width: 750px) { margin-right: 1.5rem; }
							@media(min-width: 870px) { margin-right: 2.2rem; }
						}
					}
				}
			}
			.navigation_items {
				border-bottom: 1px solid color.$separator;
				border-top: 1px solid color.$separator;
				padding: 3rem 0;
				margin: 0 0 1.8rem 0;
				display: flex;
				justify-content: flex-start;
				flex-wrap: wrap;
				gap: 1rem 6rem;
				@media(min-width: 870px) {
					display: grid;
					grid-template-columns: repeat(4, 1fr);
					grid-template-rows: 1fr;
					grid-column-gap: 5rem;
					margin: 0 0 3.5rem 0;
				}
				@media(screen.$md) { padding: 3.5rem 0 2.7rem 0; }
				@media(screen.$xl) { grid-column-gap: 8rem; }
				>article {
					margin: 0 0 1.2rem 0;
					height: fit-content;
					&:nth-of-type(1) {
						@media(min-width: 870px) { grid-area: 1 / 1 / 2 / 2; }
					}
					&:nth-of-type(2) {
						@media(min-width: 870px) { grid-area: 1 / 2 / 2 / 3; }
					}
					&:last-child {
						margin: unset;
						@media(min-width: 870px) { grid-area: 1 / 3 / 2 / 5; }
					}
					h6 {
						margin: 0 0 0.35rem 0;
						text-transform: uppercase;
						color: color.$on-background-low-importance;
						@media(min-width: 870px) { margin: 0 0 0.65rem 0; }
					}
					>div {
						display: inline-flex;
						flex-direction: column;
						a {
							color: color.$on-background-high-importance;
							font-weight: 500;
							margin: 0.25rem 0;
							text-wrap: nowrap;
						}
					}
				}
			}
			.information_section {
				.terms {
					margin: 0 0 1.6rem 0;
					a {
						position: relative;
						color: color.$on-background-medium-importance;
						font-weight: 500;
						text-wrap: nowrap;
						display: inline-block;
						margin-right: 2.2rem;
						margin-bottom: 0.75rem;
						&:after {
							position: absolute;
							top: 50%;
							left: calc(100% + 1.1rem);
							content: "";
							background: color.$on-background-low-importance;
							width: 1px;
							height: 12px;
							transform: translateY(-50%);
						}
						&:last-child {
							&:after { display: none; }
						}
					}
				}
				.pty {
					margin-bottom: 2rem;
					@media(min-width: 870px) { margin-bottom: 2.3rem; }
					p {
						color: color.$on-background-medium-importance;
						span {display: block;}
					}
				}
			}
		}
	}
</style>